export const ticketQueue = {
  name: "Fila de Atendimento |||| Filas de Atendimento",
  fields: {
    name: "Nome",
    description: "Descrição",
    color: "Cor",
    isDefault: "Fila Padrão",
    greetingMessage: "Mensagem de Boas-vindas",
    outOfHoursMessage: "Mensagem Fora do Horário",
    schedules: "Horário de Funcionamento",
  },
  none: "Sem fila",
  default: "Padrão",
  noQueues: "Nenhuma fila disponível",
  errors: {
    CANNOT_DELETE_DEFAULT_QUEUE: "Não é possível excluir a fila padrão. Defina outra fila como padrão primeiro.",
    CANNOT_DELETE_LAST_QUEUE: "Não é possível excluir a única fila restante. É necessário ter pelo menos uma fila.",
    CANNOT_DELETE_QUEUE_WITH_ACTIVE_TICKETS: "Não é possível excluir a fila com %{activeTicketsCount} ticket(s) ativo(s). Reatribua ou feche-os primeiro.",
    CANNOT_UNSET_DEFAULT_QUEUE: "Não é possível remover a fila padrão. Defina outra fila como padrão primeiro.",
    deleteFailed: "Erro ao excluir fila",
    updateFailed: "Erro ao atualizar fila",
  },
};
